import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadBrandingCriteria {
    brandingId: number;
}

class ReadBrandingCriteriaImpl implements ReadBrandingCriteria {
    constructor(readonly brandingId: number) {}
}

export class ReadBrandingCriteriaBuilder {
    private brandingId: Option<number> = none;

    static create = (): ReadBrandingCriteriaBuilder => new ReadBrandingCriteriaBuilder();

    withBrandingId = (brandingId: number): ReadBrandingCriteriaBuilder => {
        this.brandingId = some(brandingId);
        return this;
    };

    build = (): ReadBrandingCriteria => {
        if (isNone(this.brandingId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadBrandingCriteriaImpl(this.brandingId.value);
    };
}
